'use strict';

class CInputNumericController {
    constructor(Util, $scope, $compile, $element) {
      'ngInject';
      this.Util = Util;
      this.$scope = $scope;
      this.$compile = $compile;
      this.$element = $element;
    }

    $onInit() {
      this.verificarAtributosAdicionales();
      if (this.Util.isEmpty(this.ngModel)) {
        this.ngModel = undefined;
      }
    }

    verificarAtributosAdicionales() {
      if (this.ngDirectives) {
        const directivas = this.Util.limpiarEspaciosDobles(this.ngDirectives).split(' ');
        for (let i = 0; i < directivas.length; i++) {
          this.$compile(this.$element.find('input').attr(directivas[i], ''))(this.$scope);
        }
      }
    }
}
export default CInputNumericController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components/c-input-numeric/c-input-numeric.controller.js